<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-select v-model='yuvceType' @change="theyuvtypeChange" size="small" clearable placeholder="请选择类型">
                    <el-option label="公司" :value="1">
                    </el-option>
                    <el-option label="楼宇" :value="2">
                    </el-option>
                    <el-option label="物业" :value="3">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">

            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getUserVisitorCustomizeList' api='getUserVisitorCustomizeList' :height="H - 145" :paginate="2">
        </mytable>

        <myform :viewobj='{
            updateUserVisitorCustomize: ["修改自定义字段信息", "el-icon-edit-outline"],
            $succeed$: getUserVisitorCustomizeList
        }' @close='$form("updateUserVisitorCustomize", "reset")' @confirm='myform'>
            <hide slot='yuvceId' />
            <template v-slot:yuvcePattern="{ Myformdata }">
                <el-select v-model='Myformdata.yuvcePattern' clearable @change="yuvcePatternVal">
                    <el-option label="字符" :value="1">
                    </el-option>
                    <el-option label="整数" :value="2">
                    </el-option>
                    <el-option label="小数" :value="3">
                    </el-option>
                    <el-option label="日期" :value="4">
                    </el-option>
                    <el-option label="定位" :value="5">
                    </el-option>
                    <el-option label="单选" :value="6">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:visitorCustomizeOptionArray="{ Myformdata }">
                <div v-if="yuvcePattern == 6">
                    <el-button @click="addoptions" size='small' type="primary" icon='el-icon-circle-plus'>添加选项
                    </el-button>
                    <div v-for="(item,index) in optionsArr || []" :key="index">
                        <div>
                            <el-input v-model="item.yuvceoValue" style="width: 60%;" size="small"></el-input>
                            <el-button v-if="index != 0" @click="deloptions(index)" size='small' type="primary"
                                icon='el-icon-circle-plus'>删除选项
                            </el-button>
                        </div>

                    </div>
                </div>
            </template>
            <template v-slot:yuvceShow="{ Myformdata }">
                <el-select v-model='Myformdata.yuvceShow' clearable>
                    <el-option label="否" :value="1">
                    </el-option>
                    <el-option label="是" :value="2">
                    </el-option>
                </el-select>
            </template>
            <template v-slot:yuvceNecessary="{ Myformdata }">
                <el-select v-model='Myformdata.yuvceNecessary' clearable>
                    <el-option label="否" :value="1">
                    </el-option>
                    <el-option label="是" :value="2">
                    </el-option>
                </el-select>
            </template>
        </myform>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            yuvcePattern: '',
            yuvceType: '',
            theProjectId: null,
            bmcId: null,
            optionsArr: [{
                yuvceoValue: '',
            }],
            tableColums_getUserVisitorCustomizeList: {
                $selection: false,
                yuvceType: ['字段类型', , '@v-if: 1:公司, 2:楼宇,  3:物业'],
                yuvceLabel: '字段名称',
                yuvcePattern: ['数据类型', , '@v-if: 1:字符, 2:整数,  3:小数,  4:日期,  5:定位,  6:单选'],
                yuvceShow: ['是否显示', , '@v-if: 1:否#danger, 2:是#success'],
                yuvceNecessary: ['是否必填', , '@v-if: 1:否#danger, 2:是#success'],
                $operation: [
                    '操作', 200,
                    this.updateUserVisitorCustomize && `@text: 编辑#success
               @click:yuvceEdit($row) 
            `,

                ],

            },

        };
    },

    watch: {

    },

    methods: {
        yuvcePatternVal(e) {
            this.yuvcePattern = e
        },
        yuvceEdit(row) {
            this.optionsArr = row.userVisitorCustomizeOptionList || [{
                yuvceoValue: '',
            }];
            this.yuvcePattern = row.yuvcePattern
            this.$form("updateUserVisitorCustomize", row);
        },
        myform(submit, Myformdata) {
            Myformdata.visitorCustomizeOptionArray = JSON.stringify(this.optionsArr);
            submit();
            this.optionsArr = [{
                yuvceoValue: '',
            }];
        },
        addoptions() {
            console.log(this.optionsArr);
            this.optionsArr.push({
                yuvceoValue: '',
            })
        },
        deloptions(index) {
            if (this.optionsArr.length == 1) {
                return;
            }
            this.optionsArr.splice(index, 1);
        },
        theyuvtypeChange(e) {
            this.yuvceType = e;
            this.getUserVisitorCustomizeList({ projectId: this.theProjectId, yuvceType: this.yuvceType });
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getUserVisitorCustomizeList({ projectId: this.theProjectId, yuvceType: this.yuvceType });
        },
    },


    created() {
        this.theUserProject = A.local('$projectId');
        if (this.theUserProject == 0) {
            this.getProjectList({ pageSize: 0 });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getUserVisitorCustomizeList({ projectId: this.theUserProject, yuvceType: this.yuvceType });
    },
}
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/bussiness/projectDiy.vue